export const DKCS = () => {
  // const { data } = useAuth()
  return (
    <>
      <div className="mt-8 max-w-[800px] ml-auto mr-auto pl-4 pr-4">
        <h1 xs={24} className="text-2xl font-bold text-center">
          ĐIỀU KHOẢN VÀ CHÍNH SÁCH
        </h1>
        <p className="mt-4 text-lg font-normal text-center">
          Chào mừng bạn đến với sacvietmelody.com, trang web chính thức của Công
          ty TNHH Dịch vụ và Giải trí Sắc Việt. Khi truy cập và sử dụng trang
          web này, bạn đồng ý tuân thủ các điều khoản và điều kiện sau:
        </p>
        <p className="mt-4 text-lg font-normal">
          <span className="font-bold">1. Về mục đích của trang</span> <br />
          Trang web cung cấp thông tin về dự án và các chương trình của chúng
          mình. Thông qua trang web, người dùng có thể tìm hiểu đồng thời mua vé
          tham các sự kiện Concert của Sắc Việt Melody.
        </p>

        <p className="mt-4 text-lg font-bold">
          2. Về việc mua vé tham gia sự kiện
        </p>
        <p className="mt-1 text-lg font-normal">
          * Người dùng có thể mua vé tham gia sự kiện thông qua trang web.
        </p>
        <p className="mt-1 text-lg font-normal">
          * Việc mua vé tham gia sự kiện phụ thuộc vào tình trạng chỗ trống và
          xác nhận từ ban tổ chức sự kiện.
        </p>
        <p className="mt-1 text-lg font-bold">
          * BAN TỔ CHỨC KHÔNG HOÀN HUỶ VÉ THAM GIA SỰ KIỆN DƯỚI MỌI HÌNH THỨC .
        </p>

        <p className="mt-4 text-lg font-bold">
          3. Về trách nhiệm của người dùng
        </p>
        <p className="mt-1 text-lg font-normal">
          * Người dùng phải cung cấp thông tin chính xác và đầy đủ khi mua vé
          tham gia sự kiện
        </p>
        <p className="mt-1 text-lg font-normal">
          * Người dùng không được thực hiện các hành vi gây hại cho trang web
          hoặc các người dùng khác.
        </p>
        <p className="mt-1 text-lg font-normal">
          * Bất kỳ hành vi lạm dụng trang web nào cũng có thể dẫn đến việc chấm
          dứt quyền truy cập.
        </p>

        <p className="mt-4 text-lg font-bold">4. Về quyền sở hữu trí tuệ</p>
        <p className="mt-1 text-lg font-normal">
          * Tất cả nội dung trên trang web, bao gồm văn bản, hình ảnh và logo,
          thuộc quyền sở hữu của Concert of Childhood Memory, trừ khi có quy
          định khác.
        </p>
        <p className="mt-1 text-lg font-normal">
          * Nghiêm cấm sử dụng, sao chép hoặc phân phối nội dung mà không được
          phép.
        </p>

        <p className="mt-4 text-lg font-bold">5. Về chính sách bảo mật</p>
        <p className="mt-1 text-lg font-normal">
          * Thông tin người dùng thu thập cho việc mua vé tham gia sự kiện sẽ
          được xử lý theo chính sách bảo mật của chúng mình.
        </p>
        <p className="mt-1 text-lg font-normal">
          * Thông tin thanh toán (được xử lý an toàn bởi nhà cung cấp thanh toán
          bên thứ ba – VNPay).
        </p>
        <p className="mt-1 text-lg font-normal">
          * Chúng mình không chia sẻ dữ liệu của người dùng với bên thứ ba,
          ngoại trừ các dịch vụ thiết yếu như hỗ trợ tổ chức sự kiện, xử lý
          thanh toán hoặc giao hàng
        </p>

        <p className="mt-4 text-lg font-bold">6. Thông Tin Liên Hệ</p>
        <p className="mt-1 text-lg font-normal">
          Mọi thắc mắc, vui lòng liên hệ với chúng mình qua email:
          Tochucsukiensacviet@gmail.com
        </p>


        <p className="mt-4 text-lg font-bold">
          7. Chính sách hoàn huỷ vé 
        </p>
        <h1 xs={24} className="text-2xl font-bold mt-1 text-[#ff0000]">
          * KHÔNG HOÀN HUỶ KHI THANH TOÁN
        </h1>
      </div>
    </>
  )
}
